// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "854640b-dirty",
    "hash": "854640b",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "854640b-dirty",
    "semverString": null,
    "version": "0.0.1"
};
export const BUILD_TIMESTAMP = "2023-10-10 17:41:14";
/* tslint:enable */
